<template>
	<div>
		<v-dialog v-model="dialog_stock_journal" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialogWeb()"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">Stock Journal</v-toolbar-title>

				    <v-spacer></v-spacer>

				    <v-btn round-borders outline @click="fn_checkValidations">Done</v-btn>
				</v-toolbar>
        		<!-- <v-divider></v-divider> -->
        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width>
        	  			<v-layout wrap padding-top-bottom-ten white-background>

							<v-flex xs12 sm12 md12 align-msg-right form-item
					        	@click="fn_openProducts">

				               <v-text-field  
					               	readonly
					               	:disabled="isEdit"
					               	v-model="$parent.Form.itemName" 
					               	:hide-details="$parent.Form.summaryArray.length ? true : false"
					               	label="Select Item" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	:onUpdate="$parent.fn_updateProductName"
					               	ref="ref_fieldProductName"
					               	v-validate="'required'" 
				               		data-vv-name="item" 
				               		:error-messages="errors.collect('fields.item')"
				               		required>
				               </v-text-field>

				               <div custom-message>
				               		<span v-for="(item, index) in $parent.Form.summaryArray" v-if="$parent.Form.summaryArray.length">
	               						Stock: <span :class="{'redcolor':item.qty<0}">{{item.qty}} {{item.unitName}}</span>
				               			<!-- {{item.unitName}}<span v-if="item.packQuantity != 0 && item.packQuantity != null">({{item.packQuantity}})</span>: 
				               			<b>{{item.qty}}</b>{{$parent.Form.summaryArray.length-1 != index ? ',&nbsp;' : ''}} -->
				               		</span>
				               </div>
				            </v-flex>

						</v-layout>

						<div v-for="(transactionItem, tIndex) in $parent.Form.trProducts" :key="tIndex" :id="'section'+tIndex" :class="transactionItem.groupId" margin-top-ten>

							<v-subheader subheader-dense white-background dark-grey norightpadding>
								#{{tIndex+1}}
								<v-spacer></v-spacer>
								<v-menu v-if="!isEdit">

							      <v-btn slot="activator" icon>
							      	<v-icon>more_horiz</v-icon>
							      </v-btn>

							      <v-list nopadding>
							        <v-list-tile @click="$parent.fn_removeItem(tIndex, transactionItem.variants)">
							        	<v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							      </v-list>

							    </v-menu>
							</v-subheader>

							<v-divider></v-divider>

							<v-layout wrap white-background padding-top-bottom-ten>

								<v-layout row wrap>

									<v-flex xs12 sm12 md12 form-item>
						               	<v-radio-group v-model="transactionItem.transactionProductMode" row>
									      <v-radio label="Short" :value="0"></v-radio>
									      <v-radio label="Excess" :value="1"></v-radio>
									    </v-radio-group>
						            </v-flex>	

									<v-flex xs6 sm6 md6 pr-2 pl-3 v-if="$root.TransactionSettings.mrpWiseStock">
							           	<v-text-field 
							           		@focus="$parent.fn_focusItem"
							           		v-model.number="transactionItem.mrp"
							           		label="MRP" 
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		data-vv-name="mrp" 
						               		:error-messages="errors.collect('fields.mrp')">
							           	</v-text-field>
							        </v-flex>

							        <v-flex xs6 sm6 md6 pr-3 pl-2 :class="[!$root.TransactionSettings.mrpWiseStock ? 'xs12 sm12 md12 pr-3 pl-3' : 'xs6 sm6 md6 pr-3 pl-2']">
							           	<v-text-field 
							           		@focus="$parent.fn_focusItem"
							           		v-model.number="transactionItem.rate"
							           		label="Rate" 
							           		placeholder=" "
							           		type="number"
							           		v-validate="'min_value:0|decimal:2'" 
						               		data-vv-name="rate" 
						               		:error-messages="errors.collect('fields.rate')">
							           	</v-text-field>
							        </v-flex>

								</v-layout>

								<v-layout row wrap form-item grey-back v-if="transactionItem.variants.length > 1">
								  <v-subheader nopadding subheader-dense>Quantity</v-subheader>
								</v-layout>
							  	

					        	<v-layout row wrap v-for="(item, vIndex) in transactionItem.variants" :key="vIndex">
						        	<v-flex xs6 sm6 md6 pl-3 pr-3>
							           	<v-text-field 
							           		@focus="fn_focusItem"
							           		v-model.number="item.qty"
							           		label="Quantity" 
							           		placeholder=" "
							           		type="number"
							           		v-validate="'numeric|max:8'" 
						               		:data-vv-name="item.unitName+vIndex" 
						               		data-vv-as="quantity"
					               			:error-messages="errors.collect('fields.'+item.unitName+vIndex)">
							           	</v-text-field>
							        </v-flex>

							        <v-flex xs6 sm6 md6 align-msg-right pr-3 pl-3>
							           	<v-text-field 
							           		label="Unit"
							           		:value="item.label" 
							           		:disabled="true"
							           		:hint="'&#8377; '+ $root.numberToLocale(item.amount)"
							           		persistent-hint
							           		placeholder=" ">
							           	</v-text-field>
							        </v-flex>
						        </v-layout>
						        
							</v-layout>

						</div>

						<v-layout grey-back row wrap white-background v-if="!isEdit">
							<v-flex xs12 sm12 md12 right-align>
						    	<v-btn light-opacity-color class="ma-3" capitalize outline @click="$parent.fn_openTransactionProductGroups($parent.itemData.transactionProductGroups)">Add More</v-btn>

						  	</v-flex>
						</v-layout>
						
						<!-- <div display-flex v-if="!isEdit">
							<v-spacer></v-spacer>
							<v-btn flat color="blue darken-1" @click="$parent.fn_openTransactionProductGroups($parent.itemData.transactionProductGroups)">Add</v-btn>
						</div>		 -->				

						
        	  		</v-form>
        	  		
        	  	</v-card-text>
        	  	<!-- <v-divider></v-divider>
		        <v-card-actions>
		          <v-spacer></v-spacer>
		          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialog()">close</v-btn>
		          <v-btn color="blue darken-1" flat @click.native="">ok</v-btn>
		        </v-card-actions> -->
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
export default{
	props:['isEdit'],
	data(){	
		return{
			dialog_stock_journal: false,		
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.dialog_stock_journal = true;
		},
		closeDialogWeb: function () {
			this.dialog_stock_journal = false;
		},
		fn_openProducts: function () {
			if(!this.isEdit){
				this.$parent.fn_openProductsDialog(false)
			}
		},
		// fn_itemTotal: function (item, rate) {
		// 	let packQty = 1;

		// 	item.packQuantity ? packQty = item.packQuantity : '';

		// 	if(!item.qty || !rate)
		// 		item.amount = 0;
		// 	else{
		// 		item.amount = item.qty * packQty * rate;
		// 	}
		// },
		fn_checkValidations: function(){
			let quantityFilled = false;
			// let emptyGroups = [];

			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		           	for(let i=0;i<this.$parent.Form.trProducts.length;i++){
				
						// qunatityFilled = false;
						this.$parent.Form.trProducts[i].quantityFilled = false;

						let tP = this.$parent.Form.trProducts[i];
						tP.hasQuantity = false;

		    			for(let j=0;j<tP.variants.length;j++){
		    				if(tP.variants[j].qty){
		    					quantityFilled = true;
		    					this.$parent.Form.trProducts[i].quantityFilled = true;
		    					tP.hasQuantity = true;
		    					// break;
		    				}
		    			}

		    		}

		    		if(!quantityFilled){
		    			this.showToast("Please add quantity");
		    			return;
		    		}
		    		else{
		    			// for(let i=0; i<emptyGroups.length; i++){
		    			// 	this.Form.trProducts.splice(emptyGroups[i]);
		    			// }
		    			this.$parent.fn_pushItem();
		    		}
		        }
		        else{
		        	// this.$parent.snackbar = true;
		        	// this.$parent.snackbar_msg = "Please enter valid details";
		        	this.showToast("Please enter valid details");
		        }
		    });
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_journal/dialogs/dialog_stock_journal.vue